﻿export const APP_NAME = import.meta.env.VITE_APP_NAME || "Automation Engineers";

export function getDocumentTitle(pageTitle: string): string {
  return `${pageTitle} - ${APP_NAME}`;
}

/**
 * Formats a numeric count for a badge/chip so it never overflows.
 * Above the cap it shows "<cap>+" (e.g. "99+").
 * An optional suffix is appended after the number when within cap (e.g. " due").
 */
export function formatBadgeCount(
  count: number,
  { cap = 99, suffix = "" }: { cap?: number; suffix?: string } = {},
): string {
  return count > cap ? `${cap}+` : `${count}${suffix}`;
}

export function formatBytes(bytes: any, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export const formatDate = (y: number, m: number, d: number) => {
  const mm = String(m + 1).padStart(2, "0");
  const dd = String(d).padStart(2, "0");
  return `${y}-${mm}-${dd}`;
};
